import React from "react";
import {styled} from '@mui/material/styles';

const PREFIX = 'sitebranding';

const classes = {
  logoApp: `${PREFIX}-logoApp`
};

const Root = styled('a')((
  {
    theme
  }
) => ({
  [`& .${classes.logoApp}`]: {
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  }
}));

export default function SiteBranding(props: { className?: string }) {
  
  const logoClass = props.className ?? classes.logoApp;
  
  return (
    <Root href='https://www.unilode.com/' className='custom-logo-link' rel='home' aria-current='page'>
      <img className={logoClass} width='150vh' src='/unilodeLogo.svg' alt='Unilode Aviation Solutions'
           decoding='async' sizes='90vw'/>
    </Root>
  );
}
